import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

@Component({
  selector: 'app-statistics',
  standalone: true, imports: [RouterLink, RouterLinkActive, ScrollToModule],
  templateUrl: './statistics.component.html',
  styleUrl: './statistics.component.scss'
})
export class StatisticsComponent {

}
